import React, { useEffect, useState } from "react";
import { loginUser } from "../services/authService";

const DEMO_FIRM_ID = "hannah-financial-demo";

const getParam = (key: string) => {
  try {
    return new URLSearchParams(window.location.search).get(key);
  } catch {
    return null;
  }
};

const safeSessionSet = (key: string, value: string) => {
  try {
    sessionStorage.setItem(key, value);
  } catch {}
};

const safeNavigateTenant = (tenantId: string, view: string = "dashboard") => {
  const nextUrl = `/location/${tenantId}/${view}`;
  window.history.replaceState({}, "", nextUrl);
  window.dispatchEvent(new Event("filershub:navigate"));
};

const looksLikeTemplate = (v: string) => v.includes("{{") || v.includes("}}");

const SsoLaunch: React.FC = () => {
  const [status, setStatus] = useState<"boot" | "working" | "error">("boot");
  const [message, setMessage] = useState<string>("Starting secure sign-in...");

  useEffect(() => {
    const run = async () => {
      const locationId = (getParam("locationId") || "").trim();
      const userEmail = (getParam("userEmail") || "").trim();

      // ✅ DEMO BYPASS:
      // If demo firm OR the iframe is hitting this with template placeholders, do NOT call partner-sso.
      if (
        locationId === DEMO_FIRM_ID ||
        looksLikeTemplate(locationId) ||
        looksLikeTemplate(userEmail)
      ) {
        safeSessionSet("FILERSHUB_DEMO_SESSION", "1");
        safeSessionSet("FILERSHUB_SSO_LOC", DEMO_FIRM_ID);
        safeNavigateTenant(DEMO_FIRM_ID, "dashboard");
        return;
      }

      if (!locationId || !userEmail) {
        setStatus("error");
        setMessage("Missing locationId or userEmail in the launch URL.");
        return;
      }

      setStatus("working");
      setMessage("Signing you in...");

      try {
        await loginUser(userEmail, locationId);
        // loginUser already navigates to /location/{tenantId}/dashboard
      } catch (e: any) {
        console.error("SSO launch failed:", e);
        setStatus("error");
        setMessage(e?.message || "SSO sign-in failed.");
      }
    };

    run();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8 text-center">
        {status !== "error" ? (
          <div className="flex flex-col items-center gap-4">
            <div className="w-10 h-10 border-4 border-slate-200 border-t-slate-900 rounded-full animate-spin" />
            <div>
              <h1 className="text-lg font-black text-slate-900">FilersHub</h1>
              <p className="text-sm text-slate-500 mt-1">{message}</p>
            </div>
          </div>
        ) : (
          <div>
            <h1 className="text-lg font-black text-slate-900">Sign-in failed</h1>
            <p className="text-sm text-slate-500 mt-2">{message}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 px-6 py-3 rounded-xl bg-slate-900 text-white font-bold"
            >
              Try again
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SsoLaunch;
